import * as moment from 'moment';

export class DateUtilityService {
    static isBetweenDates(startDate: number, endDate: number): boolean {
        return moment(new Date()).isBetween(startDate, endDate);
    }
}
